// SPA 이동이 새 화면의 <head> 스타일시트를 붙일 때 "이미 있는 것" 을 가리는 순수 도우미
// (HRGA P5 Task 4 리뷰 2차, R30). DOM 도 import 도 없다 — calendar-history.js 의 adoptHeadStyles 와
// Node 단위 테스트(tests/unit/head-styles.test.mjs)가 같은 함수를 쓴다.
//
// 같은 파일인지는 **경로**로 가린다(origin + pathname, 쿼리·조각은 보지 않는다): 전역 스타일시트와
// 화면별 CSS 에는 ?v=<assetVersion>(서버가 뜰 때마다 바뀐다, templates.go) 꼬리가 붙어 있어서, 전체
// 주소로 비교하면 서버를 다시 띄운 뒤의 첫 이동이 이미 있는 시트를 <head> 끝에 한 벌 더 붙여 캐스케이드
// 순서를 뒤집었다. 이미 있는 시트는 새로 붙이지도, 옮기지도, 주소를 바꾸지도 않는다 — 옛 버전은
// 다음 전체 로드까지 그대로 둔다.

// styleKey(href, base) → 'https://host/static/css/x.css' 꼴의 비교 열쇠, 해석할 수 없으면 ''.
export function styleKey(href, base) {
    if (!href) return '';
    try {
        const u = new URL(href, base);
        return u.origin + u.pathname;
    } catch (_) {
        return '';
    }
}

// newStyleIndexes(haveHrefs, wantHrefs, base) → wantHrefs 가운데 붙여야 할 것의 색인(입력 순서).
//  haveHrefs: 지금 문서의 스타일시트 href, wantHrefs: 새 문서의 것. 경로가 이미 있거나(쿼리만 다른
//  것 포함), 해석할 수 없거나, 새 문서 안에서 앞에 같은 경로가 나온 것은 뺀다.
export function newStyleIndexes(haveHrefs, wantHrefs, base) {
    const seen = new Set();
    for (const h of haveHrefs || []) {
        const k = styleKey(h, base);
        if (k) seen.add(k);
    }
    const out = [];
    (wantHrefs || []).forEach((h, i) => {
        const k = styleKey(h, base);
        if (!k || seen.has(k)) return;
        seen.add(k);
        out.push(i);
    });
    return out;
}
